var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5374 20.7979C17.9005 21.1134 17.3103 21.4473 16.6896 21.7055C15.3566 22.2607 13.989 22.3775 12.5644 22.0312C10.4683 21.5232 8.89512 20.3493 7.86332 18.4563C6.93328 16.7477 6.77454 14.9366 7.29146 13.0662C7.8735 10.9499 9.18818 9.41746 11.1561 8.53858C12.017 8.15547 13.004 8.02231 13.9483 7.8748C14.5161 7.78466 14.9882 8.25586 15.0004 8.74549C15.0126 9.28225 14.6463 9.61823 13.9992 9.66126C11.5754 9.8231 9.62369 11.2449 9.00705 13.5476C8.41483 15.7602 9.00502 17.9298 11.0137 19.3925C13.6837 21.3347 17.4446 20.4087 18.8753 17.4278C19.2274 16.6964 19.3026 15.8278 19.4838 15.0186C19.6201 14.4142 19.9132 14.1458 20.4484 14.197C20.9552 14.2442 21.2116 14.5761 21.2136 15.2173C21.2177 16.5858 20.8208 17.8376 20.076 18.9705C19.844 19.3229 19.8562 19.5544 20.1594 19.8535C21.0305 20.7098 21.8913 21.5764 22.7257 22.4696C23.2141 22.9921 23.0208 23.7152 22.3736 23.9529C21.9544 24.1065 21.6491 23.8771 21.3805 23.6108C20.5705 22.8138 19.7728 22.0025 18.9689 21.1995C18.8264 21.0581 18.6738 20.9249 18.5374 20.8V20.7979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 10.8577C14.2208 10.5763 14.583 10.3619 14.7886 10.2513C15.218 10.0198 15.6759 9.83128 16.1399 9.67968C16.6466 9.51374 16.8969 9.12859 17.0903 8.68812C17.2388 8.34804 17.2938 7.95469 17.4871 7.64534C17.6581 7.36876 17.9633 7 18.2116 7C18.4599 7 18.7754 7.36057 18.9463 7.63509C19.1478 7.95879 19.2312 8.35828 19.3533 8.72704C19.6016 9.47481 20.2752 9.66329 20.8939 9.92348C21.1585 10.0341 21.4576 10.0997 21.6794 10.2677C21.8545 10.4008 22.0336 10.659 22.0336 10.8618C22.0336 11.0666 21.8667 11.3555 21.6876 11.46C21.2684 11.7079 20.8125 11.9148 20.3444 12.048C19.7848 12.2098 19.5263 12.6154 19.3269 13.0948C19.1844 13.439 19.1274 13.8303 18.9341 14.1376C18.7692 14.3999 18.464 14.7338 18.2177 14.7358C17.9756 14.7379 17.6642 14.404 17.5034 14.1438C17.304 13.8201 17.2205 13.4206 17.0964 13.0518C16.8501 12.3184 16.2294 12.0582 15.5884 11.8165C15.3035 11.7099 15.0002 11.628 14.7499 11.4661C14.5606 11.3453 14.2208 11.125 14.2208 10.8536L14.2188 10.8577Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 5,
    y1: 23,
    x2: 27,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B88333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#445162"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSearchIcon);
export default __webpack_public_path__ + "static/media/ai-search-icon.20da1053c3df359027e04b5d70f8c5aa.svg";
export { ForwardRef as ReactComponent };